<template>
  <div class="history-museum">
    <div class="item-div">
      <p class="year">역대 감독</p>
      <p class="title record">전남드래곤즈 역대 감독</p>

      <div v-for="(item, index) in list" :key="index" class="former-director">
        <ul>
          <li><img :src="imageSrc(item.img)" :alt="item.img"></li>
          <li>
            <p v-if="item.num !== null" class="num">{{item.num}}대<span class="period">{{item.period}}</span></p>
            <p v-else class="num">대행<span class="period">{{item.period}}</span></p>
            <p class="name">{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormerDirector',
  data() {
    return {
      list: []
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.list = [
        {
          num: 1,
          period: '1994. 12 ~ 1995. 12',
          name: '故 정병탁',
          img: 'former_director_01'
        }, {
          num: 2,
          period: '1996. 1 ~ 1997. 12',
          name: '허정무',
          img: 'former_director_02'
        }, {
          num: 3,
          period: '1998. 1 ~ 2003. 12',
          name: '이회택',
          img: 'former_director_03'
        }, {
          num: 4,
          period: '2004. 1 ~ 2004. 12',
          name: '이장수',
          img: 'former_director_04'
        }, {
          num: 5,
          period: '2005. 1 ~ 2007. 12',
          name: '허정무',
          img: 'former_director_05'
        }, {
          num: 6,
          period: '2008. 1 ~ 2010. 11',
          name: '박항서',
          img: 'former_director_06'
        }, {
          num: 7,
          period: '2010. 11 ~ 2012. 8',
          name: '정해성',
          img: 'former_director_07'
        }, {
          num: 8,
          period: '2012. 8 ~ 2014. 12',
          name: '하석주',
          img: 'former_director_08'
        }, {
          num: 9,
          period: '2015. 1 ~ 2016. 10',
          name: '노상래',
          img: 'former_director_09'
        }, {
          num: 10,
          period: '2016. 10 ~ 2016. 11',
          name: '송경섭',
          img: 'former_director_10'
        }, {
          num: 11,
          period: '2016. 11 ~ 2017',
          name: '노상래',
          img: 'former_director_09'
        }, {
          num: 12,
          period: '2018. 1 ~ 2018. 8',
          name: '故 유상철',
          img: 'former_director_12'
        }, {
          num: null,
          period: '2018. 8 ~ 2018. 12',
          name: '김인완',
          img: 'former_director_12_대행'
        }, {
          num: 13,
          period: '2019. 1 ~ 2019. 7',
          name: '파비아노',
          img: 'former_director_13'
        }, {
          num: null,
          period: '2019. 7 ~ 2019. 12',
          name: '전경준',
          img: 'former_director_14'
        }, {
          num: 14,
          period: '2020. 1 ~ 2022. 6',
          name: '전경준',
          img: 'former_director_14'
        }, {
          num: 15,
          period: '2022. 6 ~ 2024. 12',
          name: '이장관',
          img: 'former_director_15'
        }, {
          num: 16,
          period: '2024. 12 ~ 2025. 12',
          name: '김현석',
          img: 'former_director_16'
        }, {
          num: 17,
          period: '2025.12 ~ 2026.04',
          name: '박동혁',
          img: 'former_director_17'
        }, {
          num: 18,
          period: '2026.05 ~',
          name: '임관식',
          img: 'former_director_18'
        }
      ];
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/club/director/'+imgSrc+'.png');
    },
  }
}
</script>
